export const CURRENCY_YEAR_ARCHIVE_SOURCE = {
  cash: 'cash',
  nbu: 'nbu',
  interbank: 'interbank',
  banks: 'banks',
  cards: 'cards',
};

export const CURRENCY_YEAR_ARCHIVE_DEFAULT_SOURCE =
  CURRENCY_YEAR_ARCHIVE_SOURCE.cash;

export const CURRENCY_YEAR_ARCHIVE_SOURCE_FILTER_OPTIONS = [
  CURRENCY_YEAR_ARCHIVE_SOURCE.cash,
  CURRENCY_YEAR_ARCHIVE_SOURCE.nbu,
  CURRENCY_YEAR_ARCHIVE_SOURCE.interbank,
  CURRENCY_YEAR_ARCHIVE_SOURCE.banks,
  CURRENCY_YEAR_ARCHIVE_SOURCE.cards,
];

export const CURRENCY_YEAR_ARCHIVE_PRIMARY_CURRENCIES = ['usd', 'eur', 'pln'];
